import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ProvideWorkflow, useWorkflow } from "../context/WorkflowContext";
import { ProvideWorkflowExecution } from "../context/WorkflowExecutionContext";
import { ProvideWorkflowGeneration } from "../context/WorkflowGenerationContext";
import { BrowserAutomationProvider } from "../context/BrowserAutomationContext";
import { ChatProvider } from "./ChatContext";
import { EditorProvider } from "./EditorContext";
import { useConfirm } from "../hooks/useConfirm";
import MainLayout from "../Layouts/main";

export default function ChatWrapper({ Layout }) {
    const { workflowId } = useParams();
    const [confirm, ConfirmDialog] = useConfirm();

    const LayoutComponent = Layout || MainLayout;
    const layoutProps = Layout ? {headerHidden: true} : { noPadding: true, noHeader: true };

    return (
        <>
            <ProvideWorkflow workflowId={workflowId}>
                <ProvideWorkflowExecution workflowId={workflowId}>
                    <ProvideWorkflowGeneration workflowId={workflowId}>
                        <ChatProvider confirm={confirm}>
                            <EditorProvider>
                                <BrowserAutomationProvider>
                                    <ChatTitleHelmet />
                                    <LayoutComponent {...layoutProps}>
                                        <Outlet confirm={confirm} />
                                    </LayoutComponent>
                                </BrowserAutomationProvider>
                            </EditorProvider>
                        </ChatProvider>
                    </ProvideWorkflowGeneration>
                </ProvideWorkflowExecution>
            </ProvideWorkflow>
            <ConfirmDialog />
        </>
    );
}

function ChatTitleHelmet() {
    const { workflow } = useWorkflow();
    const workflowTitle = workflow?.name || "Chat";

    return (
        <Helmet>
            <title>{`${workflowTitle} - AgentUI`}</title>
        </Helmet>
    );
}
